import React, { useState } from "react";
import { Redirect } from "react-router";

import Logo from "../../assets/images/logo.png";

import "./emptypage.scss";

export default function EmptyPage(props) {
  const [redirect, setRedirect] = useState(false);
  return (
    <div className="empty-page d-flex justify-content-center align-items-center w-100 ">
      <div className="wrapper d-flex flex-column align-items-center">
        <div className="img-cont">
          <img src={Logo} width="auto" height="auto" alt="" />
        </div>
        <div className="empty-bold-text mt-3">Application Received</div>
        <div className="empty-text">
          Your store will be approved after your application reviewed by admin
        </div>
        <button
          className="explore-alisuq"
          type="button"
          onClick={() => setRedirect(true)}
        >
          Explore AliSouq
        </button>
      </div>
      {redirect && <Redirect to="/" />}
    </div>
  );
}
